<template>
 <div class="help-fourth-page">
  <div :class="lang === 'en' ? 'help-seventh-page-image-content-en' : 'help-seventh-page-image-content-rs'" ></div>
  <div class="help-text-content-seventh-lower" data-langname="lb_help_7">
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      lang: this.$route.query.lang
    };
  }
}
</script>